<mat-progress-bar
	*ngIf="businessSwitchState.switching$ | async"
	class="business-switch-progress"
	mode="indeterminate"
	aria-label="Switching business"
	i18n-aria-label
></mat-progress-bar>
<div class="app-wrapper" @fade [@routerTransition]="getAnimationSettings()" *ngIf="!loading">
	<router-outlet></router-outlet>
</div>

<div class="loading-container" *ngIf="loading">
	<mat-spinner *ngIf="customStylesLoaded$ | async" [diameter]="40"></mat-spinner>
</div>

<!-- Global upload status bar - survives navigation, mounted outside router-outlet -->
<app-global-upload-status-bar *ngIf="!isOAuthAuthorizationPage"></app-global-upload-status-bar>

<!-- End-user chat → editor transition. The editor's own regions FLIP from the
     chat/preview source rects (real continuity); this app-root bridge survives
     the navigation and covers the boot gap between the route swap and the editor
     mounting, handing off to each region's FLIP as it appears. -->
<vml-agent-transition-overlay></vml-agent-transition-overlay>
